import { Flight, Hotel, Package } from './types'
// Mock flight data
export const flights: Flight[] = [
  {
    id: 'f1',
    airline: 'American Airlines',
    flightNumber: 'AA123',
    departureAirport: 'JFK',
    departureCity: 'New York',
    departureTime: '2023-08-15T08:30:00',
    arrivalAirport: 'LAX',
    arrivalCity: 'Los Angeles',
    arrivalTime: '2023-08-15T11:45:00',
    duration: '5h 15m',
    price: 349,
    cabinClass: 'Economy',
    stops: 0,
    refundable: true,
  },
  {
    id: 'f2',
    airline: 'Delta Airlines',
    flightNumber: 'DL456',
    departureAirport: 'JFK',
    departureCity: 'New York',
    departureTime: '2023-08-15T10:15:00',
    arrivalAirport: 'LAX',
    arrivalCity: 'Los Angeles',
    arrivalTime: '2023-08-15T13:30:00',
    duration: '5h 15m',
    price: 329,
    cabinClass: 'Economy',
    stops: 0,
    refundable: false,
  },
  {
    id: 'f3',
    airline: 'United Airlines',
    flightNumber: 'UA789',
    departureAirport: 'JFK',
    departureCity: 'New York',
    departureTime: '2023-08-15T12:45:00',
    arrivalAirport: 'LAX',
    arrivalCity: 'Los Angeles',
    arrivalTime: '2023-08-15T18:15:00',
    duration: '7h 30m',
    price: 289,
    cabinClass: 'Economy',
    stops: 1,
    refundable: true,
  },
  {
    id: 'f4',
    airline: 'JetBlue',
    flightNumber: 'B6123',
    departureAirport: 'JFK',
    departureCity: 'New York',
    departureTime: '2023-08-15T15:30:00',
    arrivalAirport: 'LAX',
    arrivalCity: 'Los Angeles',
    arrivalTime: '2023-08-15T19:00:00',
    duration: '5h 30m',
    price: 359,
    cabinClass: 'Economy',
    stops: 0,
    refundable: true,
  },
]
// Mock hotel data
export const hotels: Hotel[] = [
  {
    id: 'h1',
    name: 'Grand Luxury Resort',
    address: '123 Beach Avenue',
    city: 'Los Angeles',
    country: 'USA',
    stars: 5,
    rating: 4.8,
    reviewCount: 1245,
    price: 299,
    pricePerNight: 299,
    thumbnail:
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    images: [
      'https://images.unsplash.com/photo-1566073771259-6a8506099945?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
      'https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1925&q=80',
      'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    ],
    amenities: [
      'Free Wi-Fi',
      'Swimming Pool',
      'Spa',
      'Fitness Center',
      'Restaurant',
      'Room Service',
      'Beach Access',
    ],
    refundable: true,
    mealPlan: 'Breakfast Included',
    cancellationPolicy: 'Free cancellation up to 24 hours before check-in',
  },
  {
    id: 'h2',
    name: 'Urban Boutique Hotel',
    address: '456 Downtown Street',
    city: 'Los Angeles',
    country: 'USA',
    stars: 4,
    rating: 4.5,
    reviewCount: 873,
    price: 199,
    pricePerNight: 199,
    thumbnail:
      'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
    images: [
      'https://images.unsplash.com/photo-1445019980597-93fa8acb246c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80',
      'https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
      'https://images.unsplash.com/photo-1590490360182-c33d57733427?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1974&q=80',
    ],
    amenities: [
      'Free Wi-Fi',
      'Restaurant',
      'Bar',
      'Room Service',
      'Business Center',
    ],
    refundable: true,
    mealPlan: 'Breakfast Available',
    cancellationPolicy: 'Free cancellation up to 48 hours before check-in',
  },
  {
    id: 'h3',
    name: 'Seaside Family Resort',
    address: '789 Ocean Drive',
    city: 'Los Angeles',
    country: 'USA',
    stars: 4,
    rating: 4.3,
    reviewCount: 1056,
    price: 249,
    pricePerNight: 249,
    thumbnail:
      'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    images: [
      'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
      'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
      'https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    ],
    amenities: [
      'Free Wi-Fi',
      'Swimming Pool',
      'Kids Club',
      'Restaurant',
      'Beach Access',
      'Parking',
    ],
    refundable: false,
    mealPlan: 'All Inclusive',
    cancellationPolicy: 'Non-refundable',
  },
  {
    id: 'h4',
    name: 'City Center Suites',
    address: '101 Main Street',
    city: 'Los Angeles',
    country: 'USA',
    stars: 3,
    rating: 4.0,
    reviewCount: 642,
    price: 159,
    pricePerNight: 159,
    thumbnail:
      'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    images: [
      'https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
      'https://images.unsplash.com/photo-1596394516093-501ba68a0ba6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
      'https://images.unsplash.com/photo-1587985064135-0366536eab42?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80',
    ],
    amenities: ['Free Wi-Fi', 'Kitchenette', 'Laundry', 'Parking'],
    refundable: true,
    mealPlan: 'No Meals',
    cancellationPolicy: 'Free cancellation up to 72 hours before check-in',
  },
]
// Generate mock packages combining flights and hotels
export const packages: Package[] = [
  {
    id: 'p1',
    flight: flights[0],
    hotel: hotels[0],
    totalPrice: flights[0].price + hotels[0].price * 7,
    savings: 250,
  },
  {
    id: 'p2',
    flight: flights[1],
    hotel: hotels[1],
    totalPrice: flights[1].price + hotels[1].price * 7,
    savings: 180,
  },
  {
    id: 'p3',
    flight: flights[2],
    hotel: hotels[2],
    totalPrice: flights[2].price + hotels[2].price * 7,
    savings: 210,
  },
  {
    id: 'p4',
    flight: flights[3],
    hotel: hotels[3],
    totalPrice: flights[3].price + hotels[3].price * 7,
    savings: 150,
  },
]
// Function to simulate API call for search results
export const searchFlights = (from: string, to: string): Flight[] => {
  // In a real app, this would make an API call with the search parameters
  return flights
}
export const searchHotels = (location: string): Hotel[] => {
  // In a real app, this would make an API call with the search parameters
  return hotels
}
export const searchPackages = (from: string, to: string): Package[] => {
  // In a real app, this would make an API call with the search parameters
  return packages
}
